import gql from 'graphql-tag';

export const CreateAutomationRuleFromTemplateMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation experimentalCreateAutomationRuleFromTemplateMutation(
			$templateId: String!
			$cloudId: String!
			$automationStack: String!
			$spaceId: String
			$parameters: [ExperimentalCreateAutomationRuleFromTemplateParameter!]
		) @experimental {
			experimentalCreateAutomationRuleFromTemplate(
				templateId: $templateId
				cloudId: $cloudId
				automationStack: $automationStack
				spaceId: $spaceId
				parameters: $parameters
			) {
				ruleId
				ruleUuid
			}
		}
	`;
